import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User added or replaced the cover image on a share link design',
  name: 'cover_image_added',
  params: [
    {
      description: 'Type of share link the cover image was added to',
      name: 'type',
      required: true,
      type: 'enum',
      values: ['board', 'collection'],
    },
  ],
};

export default META;
